import styled from 'styled-components'
import { layout } from '../../styles/GlobalVariables'

export const StyledPWithADWrap = styled.div`
  margin-bottom: ${layout.gapMedium};

  [id*='google_ads_iframe'],
  [id*='In_article_box'] {
    text-align: center;
  }
`
